import React from 'react';
//import logo from 'img/newsfetch-io.png';
//import { Link } from 'react-router-dom';
import './privacy-policy.scss';

const PrivacyPolicyPage = () => {
    return (
        <div className="d-flex flex-column align-items-center" style={{ width: '100%', padding: '50px 10px 25px 10px', backgroundColor: 'white' }}>
            {/* <div style={{ width: '350px', height: '52px', }}>
                <img style={{ width: '100%' }} src={logo} alt="newsfetch.io"/>
            </div> */}
            <div className="privacy-policy">
                <h1>Privacy Policy</h1>
                <p>
                    At Ozmosys, we respect your privacy & information security, just as we value our own.
                    This Privacy Policy describes how your personal information is collected, used, and shared when you 
                    visit or make a purchase from Ozmosys (the "Service").
                </p>
                <h3>Information We Collect</h3>
                <p>
                    When you visit the Service, we automatically collect certain information about your device, 
                    including information about your web browser, IP address, time zone, and some of the cookies that are 
                    installed on your device. Additionally, as you browse the Service, we collect information about the 
                    individual web pages or products that you view, what websites or search terms referred you to the Service, 
                    and information about how you interact with the Service. We refer to this automatically-collected information as "Device Information."
                </p>
                <p>
                    We collect Device Information using the following technologies:
                </p>
                <p>
                    "Cookies" are data files that are placed on your device or computer and often include an anonymous unique identifier. 
                    Cookies are sent to your browser from a website, and stored on your device. 
                    We use session cookies to operate the Service, and preference cookies to remember your preferences and various settings.
                </p>
                <p>
                    "Log files" track actions occurring on the Service, and collect data including your IP address, 
                    browser type, Internet service provider, referring/exit pages, and date/time stamps.
                </p>
                <p>
                    Additionally when you signup or make a purchase, or attempt to sign up or make a purchase through the Service, 
                    we collect certain information from you, including your name, billing address, payment information, email address, 
                    and phone number. We refer to this information as "Order Information." We do not store your payment card details. 
                    When we talk about "Personal Information" in this Privacy Policy, we are talking both about Device Information and Order Information.
                </p>
                <h3>
                    How We Use Your Personal Information?
                </h3>
                <p>
                    We use the collected Personal Information for various purposes:
                </p>
                <ul>
                    <li>To provide and maintain the Service and related services</li>
                    <li>To notify you about changes to the Service</li>
                    <li>To provide customer support</li>
                    <li>To gather analysis or valuable information so that we can improve the Service</li>
                    <li>To monitor the usage of the Service</li>
                    <li>To detect, prevent and address technical issues</li>
                    <li>
                        To provide you with news, special offers and general information about other goods, 
                        services and events which we offer that are similar to those that you have already 
                        purchased or enquired about unless you have opted not to receive such information.
                    </li>
                </ul>
                <p>
                    We use the Order Information that we collect generally to fulfill any orders placed through 
                    the Service (including processing your payment information, arranging for digital delivery, 
                    and providing you with invoices and/or order confirmations). Additionally, we use this Order Information to:
                </p>
                <ul>
                    <li>Communicate with you;</li>
                    <li>Screen our orders for potential risk or fraud; and</li>
                    <li>When in line with the preferences you have shared with us, provide you with information or advertising relating to our products or services.</li>
                </ul>
                <p>
                    We use the Device Information that we collect to help us screen for potential risk and fraud (in particular, your IP address), 
                    and more generally to improve and optimize our Service (for example, by generating analytics about how our customers browse 
                    and interact with the Service, and to assess the success of our marketing and advertising campaigns).
                </p>
                <h3>
                    Sharing Your Personal Information
                </h3>
                <p>
                    We share your Personal Information with third parties as follows:
                </p>
                <ul>
                    <li>We use your payment information to process secure online credit-card payments.</li>
                    <li>We use Google Analytics to help us understand how our customers use the Service</li>
                    <li>
                        We use your personal information to send email marketing campaigns, email newsletters and other 
                        informational emails to Service users and customers.
                    </li>
                </ul>
                <p>
                    Finally, we may also share your Personal Information to comply with applicable laws and regulations, 
                    to respond to a subpoena, search warrant or other lawful request for information we receive, or to otherwise protect our rights.
                </p>
                <h3>Do Not Track</h3>
                <p>Please note that we do not alter our Service's data collection and use practices when we see a Do Not Track signal from your browser.</p>
                <h3>Your Rights</h3>
                <p>You can use some of the features of the Service without registering, thereby limiting the type of information that we collect.</p>
                <p>
                    You may unsubscribe from receiving certain informational or promotional emails from us. 
                    If you wish to do so, simply follow the instructions found at the end of the email. 
                    Even if you unsubscribe, we may still contact you for informational, transactional, account-related, or similar purposes.
                </p>
                <p>
                    You can disable the use of cookies. Many browsers have an option for disabling cookies, 
                    which may prevent your browser from accepting new cookies or enable selective use of cookies. 
                    Please note that, if you choose not to accept cookies, some features and the personalization of the Service may no longer work for you.
                </p>
                <p>
                    You can also disable the use of script code (JavaScript). Many browsers have an option for disabling script code (JavaScript), 
                    which may prevent your browser from utilizing client-side code for interactive behavior on webpages. Please note that, if you choose 
                    to disable script code (JavaScript), most features of the Service will no longer work for you.
                </p>
                <p>
                    If you are a resident of the European Economic Area (EEA), your data protection rights under the General Data Protection Regulation (GDPR) 
                    allow you to access personal information we hold about you and to ask that your personal information be corrected, updated, or deleted. 
                    If you would like to exercise this right, please contact us through the contact information below.
                </p>
                <p>
                    Additionally, if you are a European resident we note that we are processing your information in order to fulfill contracts 
                    we might have with you (for example if you make an order through the Service), or otherwise to pursue our legitimate business 
                    interests listed above. Additionally, please note that your information will be transferred outside of Europe, including to 
                    Australia and the United States.
                </p>
                <h3>
                    Data Retention
                </h3>
                <p>
                    We will retain and use your Personal Information we collect from you where we have an ongoing legitimate business need to do so 
                    (for example, to provide you with a service you have requested or to comply with applicable legal, tax, or accounting requirements).
                </p>
                <p>
                    We will also retain and use your Personal Information to the extent necessary to comply with our legal obligations 
                    (for example, if we are required to retain your data to comply with applicable laws), 
                    resolve disputes, and enforce our legal agreements and policies.
                </p>
                <p>
                    When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymize it or, 
                    if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely 
                    store your personal information and isolate it from any further processing until deletion is possible.
                </p>
                <p>
                    When you signup or make a purchase through the Service, we will maintain your Order Information for our records unless 
                    and until you ask us to delete this information.
                </p>
                <h3>
                    Children's Privacy
                </h3>
                <p>
                    The Service is not intended for children under the age of 13.
                </p>
                <p>
                    We do not knowingly collect personally identifiable information from anyone under the age of 13. 
                    If you are a parent or guardian and you are aware that your Children has provided us with Personal Information, 
                    then please contact us. If we become aware that we have collected Personal Information from children without 
                    verification of parental consent, we take steps to remove that information from our servers.
                </p>
                <h3>Changes to this Privacy Policy</h3>
                <p>
                    We may update this privacy policy from time to time in order to reflect, for example, changes to our 
                    practices or for other operational, legal or regulatory reasons.
                </p>
                <p><b>
                    If you have any questions or suggestions about our Privacy Policy, do not hesitate to{' '}
                    <a style={{ textDecoration: 'underline' }} href="mailto:support@newsfetch.io">
                        contact us
                    </a>
                </b></p>
                {/* <strong style={{ fontSize: '20px' }}>
                    If you have any questions or suggestions about our Privacy Policy, do not hesitate to{' '}
                    <a style={{ textDecoration: 'underline' }} href="mailto:support@newsfetch.io">
                        contact us
                    </a>
                    .
                </strong> */}
            </div>
        </div>
    );
};
export default PrivacyPolicyPage;
